import { z } from "zod";
import {
  AGENT_RUN_KINDS,
  AGENT_RUN_STATUSES,
  ARTIFACT_KINDS,
  CANDIDATE_RESUME_STAGES,
  CANDIDATE_STATUSES,
  COST_KINDS,
  DRAFT_PURPOSES,
  DRAFT_STATUSES,
  EMAIL_STATUSES,
  ERROR_CODES,
  MESSAGE_ROLES,
  MODEL_ROLES,
  PIPELINE_STATUSES,
  RESEARCH_JOB_STATUSES,
  RESEARCH_STAGES,
  TASK_STATUSES,
  USER_ROLES,
  asNonEmptyEnumTuple,
} from "./enum-values.js";

export * from "./enum-values.js";

/** Helper: const tuple → Zod enum + TS union */
function strEnum<T extends string>(values: readonly T[]) {
  return z.enum(asNonEmptyEnumTuple(values));
}

export const userRoleSchema = strEnum(USER_ROLES);
export type UserRole = z.infer<typeof userRoleSchema>;

export const researchJobStatusSchema = strEnum(RESEARCH_JOB_STATUSES);
export type ResearchJobStatus = z.infer<typeof researchJobStatusSchema>;

export const researchStageSchema = strEnum(RESEARCH_STAGES);
export type ResearchStage = z.infer<typeof researchStageSchema>;

export const candidateResumeStageSchema = strEnum(CANDIDATE_RESUME_STAGES);
export type CandidateResumeStage = z.infer<typeof candidateResumeStageSchema>;
export type CandidatePipelineStage = CandidateResumeStage;

export const candidateStatusSchema = strEnum(CANDIDATE_STATUSES);
export type CandidateStatus = z.infer<typeof candidateStatusSchema>;

export const pipelineStatusSchema = strEnum(PIPELINE_STATUSES);
export type PipelineStatus = z.infer<typeof pipelineStatusSchema>;

export const emailStatusSchema = strEnum(EMAIL_STATUSES);
export type EmailStatus = z.infer<typeof emailStatusSchema>;

export const draftStatusSchema = strEnum(DRAFT_STATUSES);
export type DraftStatus = z.infer<typeof draftStatusSchema>;

export const draftPurposeSchema = strEnum(DRAFT_PURPOSES);
export type DraftPurpose = z.infer<typeof draftPurposeSchema>;

export const agentRunKindSchema = strEnum(AGENT_RUN_KINDS);
export type AgentRunKind = z.infer<typeof agentRunKindSchema>;

export const agentRunStatusSchema = strEnum(AGENT_RUN_STATUSES);
export type AgentRunStatus = z.infer<typeof agentRunStatusSchema>;

export const costKindSchema = strEnum(COST_KINDS);
export type CostKind = z.infer<typeof costKindSchema>;

export const artifactKindSchema = strEnum(ARTIFACT_KINDS);
export type ArtifactKind = z.infer<typeof artifactKindSchema>;

export const messageRoleSchema = strEnum(MESSAGE_ROLES);
export type MessageRole = z.infer<typeof messageRoleSchema>;

export const taskStatusSchema = strEnum(TASK_STATUSES);
export type TaskStatus = z.infer<typeof taskStatusSchema>;

export const modelRoleSchema = strEnum(MODEL_ROLES);
export type ModelRole = z.infer<typeof modelRoleSchema>;

export const errorCodeSchema = strEnum(ERROR_CODES);
export type ErrorCode = z.infer<typeof errorCodeSchema>;
